/**
 * For an exhaustive `switch` over a union's tag: a branch that reaches here only compiles if every
 * tag was already handled above it, so adding a new tag forces every such switch to be revisited
 * instead of silently falling through a `default` or an if/else chain's last `else`.
 */
export const assertNever = (value: never): never => {
    throw new Error(`Unhandled case: ${JSON.stringify(value)}`)
}
